export const msalConfig = {
    auth: {
        clientId: process.env.REACT_APP_AZURE_CLIENT_ID,
        redirectUri : process.env.REACT_APP_AZURE_REDIRECT_URI,
        authority: 'https://login.microsoftonline.com/common'
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false,
    }
};

export const loginRequest = {
    scopes: ["User.Read"],
};